import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const simSlice = createSlice({
    name: "simMaster",
    initialState,
    reducers: {
        modifyMaster: (state, action) => {
            const { simId, details } = action.payload;
            state[simId] = {
                ...state[simId],
                ...details,
            };
            return state;
        },
        modifyModel: (state, action) => {
            state.masterModel = action.payload.masterModel
            return state;
        },
    },
});

// Action creators are generated for each case reducer function
export const { modifyMaster, modifyModel } = simSlice.actions;

export default simSlice.reducer;
